import './interest.scss';

export default () => {

};
